export default __webpack_public_path__ + "static/media/add-admin.afa14a14.svg";